<app-admin-dashboard>
  <p-card header="{{ 'AdminDownloadedDocuments.Report.PageTitle' | translate }}">
    <form [formGroup]="form">
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-3">
          <label for="startDate" style="font-weight: bolder">{{ 'AdminDownloadedDocuments.Report.StartDate' | translate }}</label>
          <p-calendar
            inputId="startDate"
            formControlName="startDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showButtonBar]="true"
            placeholder="dd/mm/aaaa"
          >
          </p-calendar>
        </div>
        <div class="field col-3">
          <label for="endDate" style="font-weight: bolder">{{ 'AdminDownloadedDocuments.Report.EndDate' | translate }}</label>
          <p-calendar
            inputId="endDate"
            formControlName="endDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showButtonBar]="true"
            placeholder="dd/mm/aaaa"
          >
          </p-calendar>
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="email" style="font-weight: bolder">{{ 'AdminDownloadedDocuments.Report.Email' | translate }}</label>
          <input id="email" type="text" pInputText formControlName="email" />
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="subject" style="font-weight: bolder">{{ 'AdminDownloadedDocuments.Report.Subject' | translate }}</label>
          <input id="subject" type="text" pInputText formControlName="subject" />
        </div>
      </div>
      <div class="p-fluid formgrid mr-2 ml-2 grid">
        <div class="field col-6">
          <label for="fromName" style="font-weight: bolder">{{ 'AdminDownloadedDocuments.Report.FromName' | translate }}</label>
          <input id="fromName" type="text" pInputText formControlName="fromName" />
        </div>
      </div>
    </form>
    <div class="p-fluid formgrid mr-2 ml-2 grid">
      <div class="col-12 flex gap-2">
        <p-button
          type="button"
          styleClass="p-button-secondary"
          (click)="goBack()"
          [style]="{ width: 'fit-content' }"
        >
          {{ 'AdminDownloadedDocuments.Report.BackButton' | translate }}
        </p-button>
        <p-button
          type="button"
          (click)="downloadReport()"
          [loading]="loadingBtnDownload"
          [disabled]="form.invalid"
          [style]="{ width: 'fit-content' }"
        >
          {{ 'AdminDownloadedDocuments.Report.ExportButton' | translate }}
        </p-button>
      </div>
    </div>
  </p-card>
</app-admin-dashboard>
